import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Device_Interface, Empty_Device_Interface } from 'src/app/Interface/Device_Interface';
import { Device_MANUFACTURE_Detail_Interface, Empty_Device_MANUFACTURE_Detail_Interface } from 'src/app/Interface/Device_MANUFACTURE_Detail_Interface';
import { Device_MANUFACTURE_Interface, Empty_Device_MANUFACTURE_Interface } from 'src/app/Interface/Device_MANUFACTURE_Interface';
import { Device_MPE_Interface, Empty_Device_MPE_Interface } from 'src/app/Interface/Device_MPE_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_QUANTITY_Interface, QUANTITY_Interface } from 'src/app/Interface/QUANTITY_Interface';
import { Unit_Interface } from 'src/app/Interface/Unit_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DataEntityMainService } from 'src/app/Service/DataEntity/DataEntityMain.service';
import { DeviceService } from 'src/app/Service/Device/Device.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { QUANTITYService } from 'src/app/Service/QUANTITY/QUANTITY.service';
import { UnitService } from 'src/app/Service/Unit/Unit.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-DeviceAdd',
  templateUrl: './DeviceAdd.component.html',
  styleUrls: ['./DeviceAdd.component.scss']
})
export class DeviceAddComponent implements OnInit {

  constructor(
    private Device_Service:DeviceService,
    private Nav_Service:NavService,

    private modalService: BsModalService,
    private Unit_Service:UnitService,
    private Quantity_Service:QUANTITYService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.MPEDevice=new FormGroup({
      id :new FormControl(),
      Mpe_Min:new FormControl(null,[Validators.required]),
      Mpe_Max:new FormControl(null,[Validators.required]),
      Mpe_Sys:new FormControl(null,[Validators.required]),
      Mpe_Rnd:new FormControl(null,[Validators.required]),
      Mpe_Goal:new FormControl(null,[Validators.required]),
    })

    this.AddNewDevice=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,[Validators.required]),
      observation :new FormControl(null,[Validators.required]),
    })

    this.Device_MANUFACTURE_FORM=new FormGroup({
      id :new FormControl(),
      MANUFACTURE:new FormControl(null,[Validators.required,Validators.pattern('^[a-zA-Z0-9]*$')]),
      MODEL:new FormControl(null,[Validators.required,Validators.pattern('^[a-zA-Z0-9]*$')]),
    })

    this.Device_MANUFACTURE_Detail_FORM=new FormGroup({
      id :new FormControl(),
      RANGE_MIN:new FormControl(null,[Validators.required, Validators.pattern("^[- +()0-9]+(.[0-9]{0,5})?$")]),
      RANGE_MAX:new FormControl(null,[Validators.required, Validators.pattern("^[- +()0-9]+(.[0-9]{0,5})?$")]),
      RANGE_Vahed_id:new FormControl('0',Validators.required),
      RESOLUTION:new FormControl(null,[Validators.required, Validators.pattern("^[- +()0-9]+(.[0-9]{0,5})?$")]),
      RESOLUTION_Vahed_id:new FormControl('0',Validators.required),
    })

    this.Nav_Service.CheckValidPage(18).subscribe(
      data=>{
        this.ReadData_Unit()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }



  //#region  Form Add

  AddNewDevice:FormGroup;

  get_Form_Title(){
    return this.AddNewDevice.get('Title') as FormControl;
  }
  get_Form_observation(){
    return this.AddNewDevice.get('observation') as FormControl;
  }

  //#endregion


  InProccessing:boolean=false

  SubmitAddNewDevice(){
    if(this.Data_Seleted_Record.id==0)
    {
      this.Alertify_Service.ErrorMessage("زیر کمیت را انتخاب کنید")
    }

    else{
      var Record:Device_Interface =Empty_Device_Interface()
      Record.id=0
      Record.title = this.get_Form_Title().value
      Record.observation = Number(this.get_Form_observation().value);
      Record.quantity_id = this.Data_Seleted_Record.id

      this.InProccessing=true
      this.Device_Service.AddDevice(Record,
        this.UploadImageSrc_List,
        this.Device_MANUFACTURE_List,
        this.Device_MPE_List).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-2){
            this.Alertify_Service.ErrorMessage("نام دستگاه وارد شده ، در لیست وجود دارد")
          }
          else{
            this.Device_MANUFACTURE_List=[]
            this.Device_MPE_List=[]
            this.Device_MANUFACTURE_Detail_List=[]
            this.Device_MANUFACTURE_FORM.reset()
            this.Device_MANUFACTURE_Detail_FORM.reset()
            this.get_Device_MANUFACTURE_FORM_RANGE_Vahed_id().setValue("0")
            this.get_Device_MANUFACTURE_FORM_RESOLUTION_Vahed_id().setValue("0")
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
            this.AddNewDevice.reset()
          }
        },error=>{
          // AuthInterceptor owns authentication; feature errors must preserve credentials.
        }
      )
    }
  }




  //#region  کمیت

  modalRef_QUANTITY: any;
  page:number=0

  ProcssingQUANTITY:boolean=false

  Search_Name_QUANTITY_Table:string=''

  openModal_QUANTITY(template: TemplateRef<any>) {
    this.modalRef_QUANTITY = this.modalService.show(template);
  }

  DataList_QUANTITY:Array<QUANTITY_Interface>=[]
  Data_Seleted_Record:QUANTITY_Interface=Empty_QUANTITY_Interface()



  ReadData_QUANTITY(){
    this.ProcssingQUANTITY=true
    this.Quantity_Service.GetActive().subscribe(
      data=>{
        this.DataList_QUANTITY=data
        this.ProcssingQUANTITY=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Set_Selected_QUANTITY_Record(item){
    this.Data_Seleted_Record=item
    this.modalRef_QUANTITY.hide()
  }

  //#endregion

  //#region Unit

  DataList_Unit:Array<Unit_Interface>=[]
  ReadData_Unit(){
    this.Unit_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Unit=data

      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Find_Unit_Title(id)
  {
      for(let item of this.DataList_Unit){
        if(item.id==id)
        {
          return item.title
        }
      }
  }

  //#endregion

  //#region  Device MANUFACTURE
  List_MANUFACTURE_Edit_Id:number=-1
  Device_MANUFACTURE_FORM:FormGroup;
  Device_MANUFACTURE_Detail_FORM:FormGroup;
  Device_MANUFACTURE_List:Array<Device_MANUFACTURE_Interface>=[]
  Device_MANUFACTURE_Detail_List:Array<Device_MANUFACTURE_Detail_Interface>=[]

  get_Device_MANUFACTURE_FORM_Id(){
    return this.Device_MANUFACTURE_FORM.get('id') as FormControl;
  }

  get_Device_MANUFACTURE_FORM_MANUFACTURE(){
    return this.Device_MANUFACTURE_FORM.get('MANUFACTURE') as FormControl;
  }

  get_Device_MANUFACTURE_FORM_MODEL(){
    return this.Device_MANUFACTURE_FORM.get('MODEL') as FormControl;
  }


  get_Device_MANUFACTURE_FORM_RANGE_MIN(){
    return this.Device_MANUFACTURE_Detail_FORM.get('RANGE_MIN') as FormControl;
  }

  get_Device_MANUFACTURE_FORM_RANGE_MAX(){
    return this.Device_MANUFACTURE_Detail_FORM.get('RANGE_MAX') as FormControl;
  }

  get_Device_MANUFACTURE_FORM_RANGE_Vahed_id(){
    return this.Device_MANUFACTURE_Detail_FORM.get('RANGE_Vahed_id') as FormControl;
  }

  get_Device_MANUFACTURE_FORM_RESOLUTION(){
    return this.Device_MANUFACTURE_Detail_FORM.get('RESOLUTION') as FormControl;
  }

  get_Device_MANUFACTURE_FORM_RESOLUTION_Vahed_id(){
    return this.Device_MANUFACTURE_Detail_FORM.get('RESOLUTION_Vahed_id') as FormControl;
  }

  Submit_Device_MANUFACTURE_Detail_FORM(){
    var temp:Device_MANUFACTURE_Detail_Interface=Empty_Device_MANUFACTURE_Detail_Interface()

    temp.rESOLUTION=this.get_Device_MANUFACTURE_FORM_RESOLUTION().value+''
    temp.rESOLUTION_Vahed_id=Number(this.get_Device_MANUFACTURE_FORM_RESOLUTION_Vahed_id().value)
    temp.rESOLUTION_Vahed=this.Find_Unit_Title(temp.rESOLUTION_Vahed_id)

    temp.rANGE_MIN=this.get_Device_MANUFACTURE_FORM_RANGE_MIN().value+''
    temp.rANGE_MAX=this.get_Device_MANUFACTURE_FORM_RANGE_MAX().value+''
    temp.rANGE_Vahed_id=Number(this.get_Device_MANUFACTURE_FORM_RANGE_Vahed_id().value)
    temp.rANGE_Vahed=this.Find_Unit_Title(temp.rANGE_Vahed_id)

    if(this.Device_MANUFACTURE_Detail_List.length>6)
    {
      this.Alertify_Service.ErrorMessage("امکان ثبت پیش از 7 مورد وجود ندارد.")
    }
    else if(temp.rESOLUTION_Vahed_id==0)
    {
      this.Alertify_Service.ErrorMessage("واحد RESOLUTION را انتخاب نمائید")
    }
    else if(temp.rANGE_Vahed_id==0)
    {
      this.Alertify_Service.ErrorMessage("واحد RANGE را انتخاب نمائید")
    }
    else if(Number(temp.rANGE_MIN)>Number(temp.rANGE_MAX))
    {
      this.Alertify_Service.ErrorMessage(" RANGE را بررسی نمائید")
    }
    else if(this.List_MANUFACTURE_Edit_Id>-1){
      this.Device_MANUFACTURE_List[this.List_MANUFACTURE_Edit_Id].detail.push(temp)
    }
    else{
      this.Device_MANUFACTURE_Detail_List.push(temp)
    }

  }

  Submit_Device_MANUFACTURE_FORM(){

    var temp:Device_MANUFACTURE_Interface=Empty_Device_MANUFACTURE_Interface()
    temp.id=Number(this.get_Device_MANUFACTURE_FORM_Id().value)
    temp.mANUFACTURE=this.get_Device_MANUFACTURE_FORM_MANUFACTURE().value
    temp.mODEL=this.get_Device_MANUFACTURE_FORM_MODEL().value
    temp.detail=this.Device_MANUFACTURE_Detail_List

    if(this.List_MANUFACTURE_Edit_Id==-1){
      this.Device_MANUFACTURE_List.push(temp)
      this.Reset_MANUFACTURE()
      this.Device_MANUFACTURE_Detail_List=[]
    }
    else if(this.List_MANUFACTURE_Edit_Id>-1)
    {
      this.Device_MANUFACTURE_List[this.List_MANUFACTURE_Edit_Id]=temp
      this.Reset_MANUFACTURE()
    }
  }

  Delete_List_MANUFACTURE(id)
  {
    this.Device_MANUFACTURE_List.splice(id,1)
    this.Alertify_Service.SuccessMessage("حذف شد")
  }

  Delete_List_MANUFACTURE_Detail(id)
  {
    this.Device_MANUFACTURE_Detail_List.splice(id,1)
    this.Alertify_Service.SuccessMessage("حذف شد")
  }

  Delete_List_MANUFACTURE_Detail_INLIST(id,List)
  {
    this.Device_MANUFACTURE_List[List].detail.splice(id,1)
    this.Alertify_Service.SuccessMessage("حذف شد")
  }

  Edot_List_MANUFACTURE(id){
    this.List_MANUFACTURE_Edit_Id=id


    var temp=this.Device_MANUFACTURE_List[id]

    this.get_Device_MANUFACTURE_FORM_Id().setValue(temp.id)
    this.get_Device_MANUFACTURE_FORM_MANUFACTURE().setValue(temp.mANUFACTURE)
    this.get_Device_MANUFACTURE_FORM_MODEL().setValue(temp.mODEL)

    this.Device_MANUFACTURE_Detail_List=temp.detail
  }

  Reset_MANUFACTURE(){
    this.List_MANUFACTURE_Edit_Id=-1
    this.Device_MANUFACTURE_FORM.reset()
    this.get_Device_MANUFACTURE_FORM_RANGE_Vahed_id().setValue("0")
    this.get_Device_MANUFACTURE_FORM_RESOLUTION_Vahed_id().setValue("0")
  }

  //#endregion

  //#region MPE
  Device_MPE_List:Array<Device_MPE_Interface>=[]
  MPEDevice: FormGroup;

  get_Form_MPEDevice_Mpe_Min(){
    return this.MPEDevice.get('Mpe_Min') as FormControl;
  }
  get_Form_MPEDevice_Mpe_Max(){
    return this.MPEDevice.get('Mpe_Max') as FormControl;
  }
  get_Form_MPEDevice_Mpe_Sys(){
    return this.MPEDevice.get('Mpe_Sys') as FormControl;
  }
  get_Form_MPEDevice_Mpe_Rnd(){
    return this.MPEDevice.get('Mpe_Rnd') as FormControl;
  }
  get_Form_MPEDevice_Mpe_Goal(){
    return this.MPEDevice.get('Mpe_Goal') as FormControl;
  }

  Delete_Device_MPE_List(id) {

    this.Device_MPE_List.splice(id,1)
    this.Alertify_Service.SuccessMessage("حذف شد")
  }

  Submit_MPEDevice_Form() {
    var temp: Device_MPE_Interface = Empty_Device_MPE_Interface()
    temp.id = 0
    temp.mpe_min=Number(this.get_Form_MPEDevice_Mpe_Min().value)
    temp.mpe_max=Number(this.get_Form_MPEDevice_Mpe_Max().value)
    temp.mpe_rnd=Number(this.get_Form_MPEDevice_Mpe_Rnd().value)
    temp.mpe_sys = Number(this.get_Form_MPEDevice_Mpe_Sys().value)
    temp.mpe_goal = Number(this.get_Form_MPEDevice_Mpe_Goal().value)



    var HasCoverInList: Boolean = false
    for (let item of this.Device_MPE_List)
    {
      if (item.mpe_min == temp.mpe_min || item.mpe_min == temp.mpe_max)
      {
        HasCoverInList=true
        break
      }
      else if (item.mpe_max == temp.mpe_min || item.mpe_max == temp.mpe_max)
      {
        HasCoverInList=true
        break
      }
    }

    if (HasCoverInList) {
      this.Alertify_Service.ErrorMessage("MPE مورد نظر دارای همپوشانی است")
    }
    else {
      this.MPEDevice.reset()
      this.Device_MPE_List.push(temp)
    }
  }

  //#endregion

  //#region Image
  BaseUrl=environment.BaseUrl
  UploadImageSrc_List:Array<General_Interface>=[]
  UploadImageSrc:string=''
  InProccessing_Image1:boolean=false
  uploadImage1(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_Image1=true

    this.Device_Service.uploadFile(formData).subscribe(
      data=>{
        this.InProccessing_Image1=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.UploadImageSrc=data['filename']
        }
      }
    )

  }

  Remove_uploadImage1(){
    this.UploadImageSrc=''
  }

  Add_uploadImage1(){
    var temp:General_Interface=Empty_General_Interface()
    temp.title=this.UploadImageSrc

    this.UploadImageSrc_List.push(temp)
    this.UploadImageSrc=''
    this.Alertify_Service.SuccessMessage("به جدول اضافه شد")
  }

  UploadImageSrc_List_Delete(id:number)
  {
    this.UploadImageSrc_List.splice(id,1)
    this.Alertify_Service.SuccessMessage("حذف شد")
  }

  modalRef_Image: any;
  ModalimageUrl:string=''
  openModal(template: TemplateRef<any>,imageUrl:string) {
    this.ModalimageUrl=imageUrl
    this.modalRef_Image = this.modalService.show(template);
  }

  //#endregion

}
